// extracted by mini-css-extract-plugin
export default {"main":"CountryOption_main__q99EE","optionName":"CountryOption_optionName__PgB95"};